import sect1_left from '../../../../assets/images/s2_1_1_sect1_left.png';
import sect1_right from '../../../../assets/images/s2_1_1_sect1_right.png';

import s2_1_7_sect2_img1 from '../../../../assets/images/s2_1_7_sect2_img1.png';
import s2_1_7_sect2_img2 from '../../../../assets/images/s2_1_7_sect2_img2.png';
import s2_1_7_sect2_img3 from '../../../../assets/images/s2_1_7_sect2_img3.png';

import s2_1_7_sect3_img from '../../../../assets/images/s2_1_7_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 W3</p>
        </div>
        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center m-col-flex between mb-4">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_7_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  대용량 배송으로 <br />

높은 효율성을 제공
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
           90L 대용량 배송으로 다양한 고객의 니즈를 만족 <br />

내부 공간을 나누어 한번에 최대 4개 목적지로 배송 <br />

하루 최대 120건의 배송으로 큰 인건비 절감
                </p>
              </div>
            </div>
            <div className="row-flex-center m-col-flex between mb-10">
              <div
                className="
                s2_1_1_sect2_item w-48 
                m-w-100 pc-none t-none"
              >
                <img src={s2_1_7_sect2_img2} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                첨단기술에 실용성이<br />
더해진 창의적인 디자인
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  정교한 유선형디자인 11.6인치 초대형 <br />
HD 터치스크린으로 고객의 눈을 사로잡습니다.
                </p>
              </div>
              <div
                className="
              s2_1_1_sect2_item w-48 m-w-100 m-none"
              >
                <img src={s2_1_7_sect2_img2} alt="" />
              </div>
            </div>
            <div className="row-flex-center m-col-flex between">
              <div className="s2_1_1_sect2_item w-48 m-w-100 ">
                <img src={s2_1_7_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">컴팩트하고 뛰어난 이동성</p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                 55cm의 좁은 공간도 자유자재로 이동.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
          <div className="txt-center mb-4">
            <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
            <p className="prt-bold fs-40 fc-black1 lh-13">
              로봇의 상세 스펙을 확인하세요
            </p>
          </div>

          <div className="flex-center mb-4">
            <img src={s2_1_7_sect3_img} alt="" />
          </div>

          <div className="">
            <div className="flex-center col-flex">
              <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100" >
                <div className="row-flex-center  between s2_1_1_sect3_inner_box">
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">48kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">수납 공간 수</p>
                    <p className="prt-bold fs-28 fc-black1">최대 4개</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">20kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 통로 폭</p>
                    <p className="prt-bold fs-28 fc-black1">70cm</p>
                  </div>
                </div>
              </div>

              <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
                <div className="row-flex between w-100 lh-14 
                s2_1_1_sect3_inner2_box m-col-flex">
                  <div className="left w-48 m-w-100 ">
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품크기
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          45.9 × 54.9 × 108.1cm <br />
                          (18.07” × 21.61” × 42.56”)
                        </p>
                      </div>
                    </div>

                    <div className="item  ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최대운행속도
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          0.8 m/s (2.63 ft/s)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          충전시간**
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          6.5시간
                        </p>
                      </div>
                    </div>

                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          내부사이즈
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          39.0 × 38.5 × 30cm <br />
                          (15.53” × 15.16” × 11.81”)
                        </p>
                      </div>
                    </div>

                    <div className="item">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          멀티 배송
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          최대 4개 목적지 / 1회
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="right w-48 m-w-100">
                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품 무게
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          48kg (106 Ibs)
                        </p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          배터리 수명*
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          최대 12시간
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          수납 공간 수
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          최대 4개 분할 가능
                        </p>
                      </div>
                    </div>

                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          적재중량
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          20kg (44 Ibs)
                        </p>
                      </div>
                    </div>
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최소 통로 폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          70cm (27.56”)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
                  *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
                  실제 결과는 다를 수 있습니다.
                  <br />
                  배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다.
                  배터리 수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
